import { SCHEDULE_X_VIEW_LABELS } from './session-schedule-calendar-schedule-x.utils';
import { SessionScheduleToolbarLayout } from './session-schedule-calendar-toolbar-layout';
import type { CalendarView } from './session-schedule-calendar-types';

export interface ScheduleXToolbarProps {
  label: string;
  view: CalendarView;
  views: CalendarView[];
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
  onViewChange: (view: CalendarView) => void;
}

/** Schedule-X toolbar; navigation callbacks are wired in {@link SessionScheduleCalendarScheduleX}. */
export function ScheduleXToolbar({
  label,
  view,
  views,
  onPrevious,
  onNext,
  onToday,
  onViewChange,
}: ScheduleXToolbarProps) {
  return (
    <SessionScheduleToolbarLayout
      label={label}
      view={view}
      views={views}
      viewLabels={SCHEDULE_X_VIEW_LABELS}
      onPrevious={onPrevious}
      onNext={onNext}
      onToday={onToday}
      onViewChange={(nextView) => onViewChange(nextView as CalendarView)}
    />
  );
}
